import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function redeployTopicClassifier(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPIC_CLASSIFIER_REDEPLOY,
    (
      organisationId,
      topicId,
      classifierId,
      configurationId,
      topicTrainingNodeId,
    ) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/topic/${topicId}/classifier/${classifierId}/configuration/` +
            `${configurationId}/redeploy/${topicTrainingNodeId}`,
          {},
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
